import { pxToRem } from '@modernhealth/vital-components';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled-base';
import { DailyPauseStatsSubHeader } from 'src/modules/scheduledContent/components/DailyPauseStatsHeader';
import { MilestoneList } from 'src/modules/scheduledContent/components/MilestoneList';
import { milestones, groupMilestones, findClosestMilestone } from '../util/milestones';

const Wrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: pxToRem(44),
    maxWidth: pxToRem(432),
    width: '100%',
});

interface Props {
    completedCount: number;
}

const milestonesPerGroup = 5;
const milestonesLengthModifier = 1.25;
const groupsCount = Math.ceil((milestones.length * milestonesLengthModifier) / milestonesPerGroup);
const groupedMilestones = groupMilestones(milestones, milestonesPerGroup, groupsCount);

export const MinimizedDailyPauseStats: React.FC<Props> = ({ completedCount }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const closestMilestone = useMemo(
        () => findClosestMilestone(milestones, completedCount),
        [completedCount],
    );

    const currentMilestones = useMemo(
        () =>
            groupedMilestones.find(
                group =>
                    group.includes(closestMilestone) &&
                    (group.slice(-1)[0] !== closestMilestone ||
                        milestones.slice(-1)[0] === closestMilestone),
            ),
        [closestMilestone],
    );

    return (
        <Wrapper>
            <DailyPauseStatsSubHeader
                text={t('dailyPause:milestones.title')}
                onClick={() => history.push('/pause/milestones')}
            />
            <MilestoneList
                milestoneList={currentMilestones || []}
                completedCount={completedCount}
            />
        </Wrapper>
    );
};
